import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SafeImage from "@/components/SafeImage";

const ModelCard = ({ model }) => {
  return (
    <article className="card" data-testid={`model-card-${model.key}`}>
      <div className="card-image">
        <SafeImage src={model.image} alt={model.title} label={model.title} loading="lazy" />
        <span className="card-image-label">{model.title}</span>
      </div>
      <div className="card-body">
        <h3 className="card-title">{model.title}</h3>
        <p className="card-text">{model.short}</p>
        <Link to={`/${model.slug}`} className="btn btn-outline card-cta" data-testid={`model-card-cta-${model.key}`}>
          Detaljnije <ArrowRight size={16} />
        </Link>
      </div>
    </article>
  );
};

export default ModelCard;
